<template>
  <ams-table
    :heading="heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
    :filtering="filtering"
    :refresh="refresh"
    :refreshed="doRefresh"
    :per_page_setting="per_page_setting"
    :reroute_name="reroute_name"
    :ams_template="ams_template"
  >
  </ams-table>
</template>

<script>
import AmsTable from './AmsTable.vue'
import {localeStringOfUTC, humanize} from '@/utils'

export default {
  components: {
    AmsTable
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    per_page_setting: {
      Type: Number
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      heading: 'Showings',
      ams_type: 'showings',
      ams_api_path: 'api/admin/v1',
      reroute_name: 'ShowingCreateScreen',
      ams_fields: [
       { 
          key: 'attributes.event-name',
          label: 'Event Name',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc'
      },
      { 
        key: 'attributes.location',
        label: 'Location',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.access-permission',
        label: 'Access Permission',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc',
        formatter: value => {
          return humanize(value)
        }
       },
       { 
          key: 'is-happening',
          label: 'Is Happening',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc'
        },
        { 
          key: 'attributes.start-at',
          label: 'Start At',
          sortable: true,
          filterable: false,
          class: 'text-right',
          sortDirection: 'asc',
          formatter: value => {
             return localeStringOfUTC(value)
          }
        },
        { 
          key: 'attributes.end-at',
          label: 'End At',
          sortable: true,
          filterable: false,
          class: 'text-right',
          sortDirection: 'asc',
          formatter: value => {
             return localeStringOfUTC(value)
          }
        },
      ],
      describe_belongs_to: [
        {
          prepend: ' ',
          type: 'collections',
          description_attr: 'name',
          append: ' '
        },
        {
          prepend: ' ',
          type: 'storage-spaces',
          description_attr: 'location',
          append: ' Items'
        }
      ],
    }
  },
  methods: {
    doRefresh() {
      this.emit('refreshed', true)
    }
  }
}
</script>